<div [ngSwitch]="navPath">
  <div class="parentMenu" *ngSwitchCase="''" style="padding: 20px 0">
    <div class="softphone-menu">
      <div class="menu-keypad" style="padding: 0 20px">
        <app-softphone-dialpad (click)="$event.stopPropagation()"></app-softphone-dialpad>
      </div>
      <div class="softphone-features">
        <div class="softphone-feature">
          <button mat-fab color="transparent" class="softphone-feature-button mat-elevation-z0 mat-stroked-button" (click)="navPush('transfer')">
            <mat-icon>phone_forwarded</mat-icon>
          </button>
          <div class="softphone-feature-label">Transfer</div>
        </div>
        <div class="softphone-feature">
          <button mat-fab color="transparent" [disabled]="alreadyTwoCalls" class="softphone-feature-button mat-elevation-z0 mat-stroked-button" (click)="navPush('add')">
            <mat-icon>add_ic_call</mat-icon>
          </button>
          <div class="softphone-feature-label">Add call</div>
        </div>
        <div class="softphone-feature" *ngIf="!callIsOnHold">
          <button mat-fab color="transparent" [disabled]="alreadyTwoCalls || callStateIsProcessing" class="softphone-feature-button mat-elevation-z0 mat-stroked-button" (click)="handleHoldCall()">
            <mat-icon>phone_paused</mat-icon>
          </button>
          <div class="softphone-feature-label" *ngIf="!callIsOnHold">Put on hold</div>
        </div>
        <div class="softphone-feature" *ngIf="callIsOnHold">
          <button mat-fab [disabled]="callStateIsProcessing" class="softphone-feature-on-hold-button mat-elevation-z0 mat-stroked-button" (click)="handleHoldCall()">
            <mat-icon>phone_paused</mat-icon>
          </button>
          <div class="softphone-feature-label" *ngIf="callIsOnHold">Unhold</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Softphone-Transfer Case -->
  <div *ngSwitchCase="'transfer'" class="w-100">
    <ng-template *ngTemplateOutlet="navHeader; context: { $implicit: { icon: 'phone_forwarded', title: 'Transfer to' } }"></ng-template>

      <app-softphone-transfer
        [lendioDirectory]="lendioDirectory"
        [lendioDirectoryIsProcessing]="lendioDirectoryIsProcessing"
        [call]="call"
        [callStateIsProcessing]="callStateIsProcessing"
        [type]="'Cold Transfer'"
        (coldTransfer)="coldTransfer($event)"
        (getLendioDirectory)="getLendioDirectory()">
      </app-softphone-transfer>

  </div>

  <!-- Add Call / ~Warm Transfer Case -->
  <div *ngSwitchCase="'add'" class="w-100">
    <ng-template *ngTemplateOutlet="navHeader; context: { $implicit: { icon: 'add_ic_call', title: 'Add call' } }"></ng-template>

      <app-softphone-transfer
        [lendioDirectory]="lendioDirectory"
        [lendioDirectoryIsProcessing]="lendioDirectoryIsProcessing"
        [call]="call"
        [callStateIsProcessing]="callStateIsProcessing"
        [type]="'Warm Transfer'"
        (warmTransfer)="warmTransfer($event)"
        (getLendioDirectory)="getLendioDirectory()">
      </app-softphone-transfer>

  </div>
</div>

<ng-template #navHeader let-context>
  <div style="border-color: lightgrey; display: flex">
    <div style="flex: 1">
      <button mat-button (click)="navPop()">
        <mat-icon inline="true" style="position: relative; bottom: 2px; margin-right: 0px;">arrow_back_ios</mat-icon>
        Back
      </button>
    </div>
    <span style="flex: 1; display: flex; align-items: center;">
      <mat-icon style="color: #08c2f0; vertical-align: middle; margin-right: 5px;">{{ context.icon }}</mat-icon>
      {{ context.title }}
    </span>
    <span style="flex: 1">&nbsp;</span>
  </div>
</ng-template>
